module.exports = __webpack_public_path__ + "static/img/remarks.762a21b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/remarks.png
// module id = lLLe
// module chunks = 69